import React from "react";
import { FaInstagram } from "react-icons/fa";
import { GlobalData, Sitelogo } from "../assets/data/GlodalData";

// Import all images from the instagram folder
// Note: You'll need to adjust this based on your actual folder structure
// If you're using Create React App or Vite, you can use dynamic imports

const InstagramSection = () => {
  // Dynamically import all images from the instagram folder
  // This approach works with Create React App
  function importAll(r) {
    return r.keys().map(r);
  }

  // Get all images from the instagram folder
  // Adjust the path based on your actual folder structure
  const instagramImages = importAll(require.context('../assets/instagram', false, /\.(png|jpe?g|svg)$/));

  // Create posts array with images and links
  const instagramPosts = instagramImages.map((image, index) => ({
    id: index + 1,
    image: image.default || image, // Handle both ES6 and CommonJS modules
    link: "https://www.instagram.com/dermaslim_wellness_vizag/"
  }));

  return (
    <section className="py-16 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Follow Us on Instagram
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Join our wellness community and discover daily transformations,
            expert tips, and behind-the-scenes moments.
          </p>
        </div>

        <div className="flex flex-col items-center gap-6 mb-8 bg-white rounded-lg p-6 shadow-sm border max-w-2xl mx-auto">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-white rounded-full overflow-hidden">
              <img
                src={Sitelogo}
                alt="DermaSlim Wellness"
                className="w-full h-full object-cover"
              />
            </div>

            <div>
              <h3 className="text-lg font-bold text-gray-900">
                @dermaslim_wellness_vizag
              </h3>
              <p className="text-gray-600 text-sm">
                Your Concern, Our Care • 7+ yrs | Skin, hair & body care
              </p>
            </div>
          </div>

          <a
            href={GlobalData.company.companyinstagram}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-900 text-white px-6 py-2 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center gap-2"
          >
            <FaInstagram />
            Follow Us
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-8 justify-center mx-auto">
          {instagramPosts.map((post) => (
            <a
              key={post.id}
              href={post.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block aspect-[4/5] overflow-hidden rounded-lg bg-gray-200 hover:opacity-90 transition-opacity"
            >
              <img
                src={post.image}
                alt={`Instagram post ${post.id}`}
                className="w-full h-full object-cover"
              />
            </a>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-flex items-center gap-4 bg-white rounded-lg px-6 py-4 shadow-sm border">
            <p className="text-gray-700">
              Join our community for daily wellness tips
            </p>
            <a
              href={GlobalData.company.companyinstagram}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-900 text-white px-4 py-2 rounded-lg font-medium hover:bg-gray-800 transition-colors text-sm flex items-center gap-2"
            >
              <FaInstagram />
              Follow
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;